import {
  Task,
  TaskDetail,
  TaskTemplateItem,
} from '@app/domain/entities/task-template.entity';
import { PaginatedResponse } from '@app/shared/models/global.model';
import {
  TaskDetailDTO,
  TaskDTO,
  TaskTemplateItemDTO,
} from '../dtos/task-template.dto';

// Maps between the API DTO and the Domain Entity
export class TaskTemplateMapper {
  tasksListToDomain(dto: PaginatedResponse<TaskDTO>): PaginatedResponse<Task> {
    return {
      page: dto.page,
      size: dto.size,
      totalElements: dto.totalElements,
      totalPages: dto.totalPages,
      data: dto.data.map(task => ({
        id: task.id,
        templateName: task.templateName,
        description: task.description,
        taskCode: task.taskCode,
        tableNum: task.tableNum,
        taskShift: task.taskShift,
        isAdhoc: task.isAdhoc,
        taskType: task.taskType,
        taskIndex: task.taskIndex,
        taskTemplateUpdateBy: task.taskTemplateUpdateBy,
        taskTemplateUpdatedAt: task.taskTemplateUpdatedAt,
        taskTemplateUpdatedByUsername: task.taskTemplateUpdatedByUsername,
        isRepeatable: task.isRepeatable,
        canAsNa: task.canAsNa,
        deleted: task.deleted,
        isActive: task.isActive,
        loading: task.loading,
        isConfigured: task.isConfigured,
      })),
    };
  }

  taskDetailsToDomain(dto: TaskDetailDTO): TaskDetail {
    return {
      id: dto.id,
      templateName: dto.templateName,
      description: dto.description,
      taskCode: dto.taskCode,
      taskShift: dto.taskShift,
      isAdhoc: dto.isAdhoc,
      isPublishChat: dto.isPublishChat,
      isAlertManagement: dto.isAlertManagement,
      isNeedApproval: dto.isNeedApproval,
      canAsNa: dto.canAsNa,
      isRepeatable: dto.isRepeatable,
      taskType: dto.taskType,
      createdAt: dto.createdAt,
      createdBy: dto.createdBy,
      updatedBy: dto.updatedBy,
      updatedAt: dto.updatedAt,
    };
  }

  taskTemplateItemToDomain(dto: TaskTemplateItemDTO): TaskTemplateItem {
    return {
      id: dto.id,
      templateName: dto.templateName,
      description: dto.description,
      taskCode: dto.taskCode,
      taskShift: dto.taskShift,
      isAdhoc: dto.isAdhoc,
      isPublishChat: dto.isPublishChat,
      isAlertManagement: dto.isAlertManagement,
      isNeedApproval: dto.isNeedApproval,
      taskType: dto.taskType,
      isSelected: dto.isSelected,
      originalId: dto.originalId,
    };
  }

  taskTemplateItemsListToDomain(
    dtos: TaskTemplateItemDTO[]
  ): TaskTemplateItem[] {
    return dtos.map(dto => this.taskTemplateItemToDomain(dto));
  }
}
